import axios from "axios";

const domain = `${process.env.VUE_APP_MAP_API_DOMAIN}`;
const repository = axios.create({
  baseURL: domain,
  headers: {
    "X-Requested-With": "XMLHttpRequest",
    "Content-Type": "application/json; charset=utf-8"
  }
});

repository.interceptors.response.use(
  response => {
    return response;
  },
  err => {
    return Promise.reject(err);
  }
);

export default {
  async auth(payload) {
    return await repository.post(
      `/webgis/MapView/index/get_external_post_info/`,
      payload
    );
  },
  getAccessURI(query) {
    return `${domain}/webgis/MapView/index${query}`;
  }
};
